document.addEventListener('DOMContentLoaded', async () => {
	/**
	 * Loads Guardian data on page load.
	 */
	const guardiansDataScript = document.getElementById('guardians-data-script');

	const isCustomer = guardiansDataScript.dataset.isCustomer?.toLowerCase() === 'true';
	if (!isCustomer) {
		console.log('⚠️ User not logged in — skipping data fetch.');
		return;
	}

	console.log('We got a customer here!');
	try {
		let guardiansRes = await cusaFetch(CUSA_ENDPOINTS.accountInfo, 'GET');
		if (guardiansRes.response.ok) {
			console.log(guardiansRes);
			let resData = guardiansRes.data.member_summary || guardiansRes.data;
			resData.userIsLoggedIn = !!resData?.membership?.tier;
			window.guardianData = resData;
			if (window._devGuardiansTier) {
				window.guardianData.membership.tier = window._devGuardiansTier;
			}
			setGGGWinVarAndPub(window.guardianData);
		} else {
			throw new Error();
		}
	} catch (error) {
		console.error(error);
		publish(PUB_SUB_EVENTS.guardianLoadingError);
	}
});

/**
 * Updates global Guardian data and publishes it for subscribers.
 * @param {Object} resData - The full response
 */
const setGGGWinVarAndPub = (resData) => {
	window.guardianData = resData.member_summary || resData;

	console.log('>>>>> in setGGGWinVarAndPub! >>>>>', window.guardianData);
	publish(PUB_SUB_EVENTS.guardianDataSet);
	publish(PUB_SUB_EVENTS.guardiansAction, window.guardianData);
	publish(PUB_SUB_EVENTS.guardianDataSet, window.guardianData);
	formatStats();
};

/**
 * Updates all DOM elements with Guardian stats.
 */
const updateGuardiansStats = () => {
	const allGuardianStatEls = document.querySelectorAll('[data-guardian-stat]');
	for (const statEl of allGuardianStatEls) {
		if (statEl.dataset.guardianStat === 'listrak_email_key') {
			statEl.href += getGuardianStats(statEl.dataset.guardianStat);
		} else {
			statEl.textContent = getGuardianStats(statEl.dataset.guardianStat);
			formatStatEl(statEl);
		}
	}
};

/**
 * Gets a Guardian stat value based on the provided type.
 * @param {string} guardianStatType - The type of Guardian stat to retrieve.
 * @returns {number|string|null} The value of the requested Guardian stat, or null if not found.
 */
getGuardianStats = (guardianStatType) => {
	switch (guardianStatType) {
		case 'available_good_points':
			return window.guardianData.good_points.available;
		case 'lifetime_good_points':
			return window.guardianData.good_points.lifetime;
		case 'total_clicks':
			return window.guardianData.total_clicks;
		case 'people_fed':
			return window.guardianData.impact.people_fed;
		case 'animals_fed':
			return window.guardianData.impact.animals_fed;
		case 'trees_planted':
			return window.guardianData.impact.trees_planted * 250;
		case 'current_streak':
			return window.guardianData.streak.current;
		case 'longest_streak':
			return window.guardianData.streak.longest;
		case 'petitions_signed':
			return window.guardianData.petitions_signed;
		case 'listrak_email_key':
			return window.guardianData.listrak_email_key;
		default:
			return null;
	}
};

/**
 * Listens for Guardian action events to update Guardian stats in the DOM.
 */
subscribe(PUB_SUB_EVENTS.guardiansAction, () => updateGuardiansStats());
